import runeUrl from "@/assets/mimir-rune.png";
import { cn } from "@/utils/cn";

interface MimirRuneProps {
  className?: string;
}

/**
 * Mímir rune mark. The PNG is used as a CSS mask and tinted with the gold-soft
 * accent (`--color-em`), matching the design handoff brand lockup.
 */
export function MimirRune({ className }: MimirRuneProps) {
  return (
    <span
      aria-hidden="true"
      className={cn("block w-[22px] h-[22px] shrink-0 bg-em", className)}
      style={{
        WebkitMaskImage: `url(${runeUrl})`,
        maskImage: `url(${runeUrl})`,
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
        maskPosition: "center",
        WebkitMaskSize: "contain",
        maskSize: "contain",
      }}
    />
  );
}
